const SERVICES = [
  {
    n: '01',
    title: 'Creator Discovery',
    body: 'Finding and vetting creators whose audiences and voices are the right fit for your brand.',
  },
  {
    n: '02',
    title: 'Influencer Partnerships',
    body: 'Outreach, negotiation, and campaign coordination with creators — from nano to mid-tier.',
  },
  {
    n: '03',
    title: 'Campaign Strategy',
    body: 'Audience research, platform selection, and campaign briefs built for consumer AI and SaaS brands.',
  },
  {
    n: '04',
    title: 'Performance & Reporting',
    body: 'Clear reporting on creator posts, audience engagement, and what is working for your brand.',
  },
];

export function Services() {
  return (
    <section id="services" className="border-line bg-cream-2 border-b">
      <div className="mx-auto max-w-6xl px-6 py-24 md:py-32">
        <div className="max-w-2xl">
          <p className="marketing-label text-clay">Services</p>
          <h2 className="font-display mt-4 text-4xl leading-tight md:text-5xl">
            What we actually do.
          </h2>
        </div>

        {/* gap-px over a `bg-line` parent draws the hairline grid without four
            separate borders that would double up where cells meet. */}
        <div className="border-line bg-line mt-12 grid gap-px overflow-hidden rounded-xl border md:grid-cols-2">
          {SERVICES.map((service) => (
            <div key={service.n} className="bg-cream p-8 md:p-10">
              <div className="flex items-baseline gap-4">
                <span className="text-clay text-xs tabular-nums">{service.n}</span>
                <h3 className="font-display text-xl">{service.title}</h3>
              </div>
              <p className="text-clay mt-4 leading-relaxed">{service.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
